import React from 'react';
import PropTypes from 'prop-types';
import MediaQueries from 'react-responsive';
import classNames from 'classnames/bind';

import PageWrap from '@marvelapp/marvel-ui/page-wrap';
import Spacing from '@marvelapp/marvel-ui/spacing';

import propTypeEmptyString from 'marketing-website/utils/customPropTypesCheck.js';

import Image from 'marketing-website/components/modules/Image';
import Shape from 'marketing-website/components/commons/Shape';
import HeadingBlock from 'marketing-website/components/modules/HeadingBlock';
import Diamonds from 'marketing-website/components/commons/Diamonds';

import contentStyles from './style/content.module.css';
import generalStyles from './style/general.module.css';
import imageStyles from './style/image.module.css';

const cx = classNames.bind({
  ...contentStyles,
  ...generalStyles,
  ...imageStyles,
});

export default function MediaSingleImage({
  alt,
  children,
  copy,
  hasShadow,
  headingSpacing,
  imageBorderRadius,
  justify,
  justifyM,
  maxWidth,
  paragraphSize,
  reversed,
  shapes,
  src,
  title,
}) {
  const singleImageClassName = cx('singleImage');
  const imageClassName = cx('image', {
    imageReversed: reversed,
  });
  const contentClassName = cx('content', {
    contentReversed: reversed,
  });

  const contentProps = {
    copy,
    justify,
    justifyM,
    paragraphSize,
    spacing: headingSpacing,
    title,
  };

  const ImageProps = {
    alt,
    borderRadius: imageBorderRadius,
    maxWidth: maxWidth || 1200,
    src,
  };

  return (
    <PageWrap size="l">
      <div className={singleImageClassName}>
        <MediaQueries maxWidth={770}>
          {src && (
            <Spacing size="l" type="margin" position="bottom">
              <Image {...ImageProps} hasShadow={hasShadow} />
            </Spacing>
          )}
        </MediaQueries>
        <div className={contentClassName}>
          <HeadingBlock {...contentProps}>{children}</HeadingBlock>
        </div>
        <div className={imageClassName}>
          {shapes && (
            <MediaQueries minWidth={770}>
              <span>
                <Shape
                  width={300}
                  height={300}
                  type="losange"
                  color="yellow"
                  top="50%"
                  left="-3%"
                />
                <Diamonds top="50%" left="-4%" size={220} />
              </span>
            </MediaQueries>
          )}
          <MediaQueries minWidth={770}>
            {src && <Image {...ImageProps} hasShadow={hasShadow} />}
          </MediaQueries>
        </div>
      </div>
    </PageWrap>
  );
}

MediaSingleImage.propTypes = {
  alt: PropTypes.string,
  children: PropTypes.node,
  copy: PropTypes.string,
  hasShadow: PropTypes.bool,
  headingSpacing: propTypeEmptyString,
  imageBorderRadius: PropTypes.string,
  justify: PropTypes.string,
  justifyM: PropTypes.string,
  maxWidth: PropTypes.number,
  paragraphSize: PropTypes.string,
  reversed: PropTypes.bool,
  shapes: PropTypes.bool,
  src: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

MediaSingleImage.defaultProps = {
  hasShadow: true,
  headingSpacing: 'l',
  imageBorderRadius: 'l',
  reversed: false,
  shapes: false,
};



// WEBPACK FOOTER //
// ./src/components/modules/Media/MediaSingleImage/index.js